module.exports = __webpack_public_path__ + "img/scene_night_light_dw_backlight@2x.db710ec3.png";